<script setup lang="ts">
import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';

import { useRtl } from '@/shared/composables';

interface FlowButtonProps {
  loading: boolean;
}

interface FlowButtonEmits {
  (e: 'submit', ...args: any[]): void;
}

const props = defineProps<FlowButtonProps>();
const emit = defineEmits<FlowButtonEmits>();

const { isRtl } = useRtl();

function onButtonClick() {
  if (!props.loading) {
    emit('submit');
  }
}
</script>

<template>
  <ButtonQC
    :loading="loading"
    v-bind="$attrs"
    size="large"
    wide
    :icon-after-content="isRtl ? 'arrow-narrow-left' : 'arrow-narrow-right'"
    @click="onButtonClick"
  >
    <slot />
  </ButtonQC>
</template>

<style scoped>
.rtl {
  .icon {
    transform: rotate(180deg);
  }
}
</style>
